import React from 'react';
import styled from 'styled-components';

import LoadingBox from './LoadingBox';
import LoadingField from './LoadingField';

const LoadingServiceDetails = () => {
  return (
    <Container>
      <Column>
        <LoadingField />
      </Column>
      <Column>
        <LoadingBox />
      </Column>
    </Container>
  );
};

const Column = styled.div`
  width: 50%;
  display: flex;
  gap: 25px;
  flex-direction: column;
  align-items: center;
`;

const Container = styled.div`
  margin: 0 auto;
  margin-top: 20px;
  padding: 20px;
  width: 1200px;
  display: flex;
  background-color: white;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
  height: 500px;
`;

export default LoadingServiceDetails;
